import type {
  Color,
  BorderRadius,
  BorderWidth,
  FontSize,
  FontWeight,
} from './types';

export type FwcColor =
  | 'fwc-alert-border-default'
  | 'fwc-badge-fill-calypso'
  | 'fwc-badge-fill-candy-apple'
  | 'fwc-badge-fill-koala'
  | 'fwc-badge-fill-lorax'
  | 'fwc-badge-fill-marigold'
  | 'fwc-badge-fill-norman'
  | 'fwc-badge-fill-oz'
  | 'fwc-badge-fill-pantera'
  | 'fwc-badge-fill-sorbet'
  | 'fwc-badge-fill-thunderdome'
  | 'fwc-badge-fill-beta'
  | 'fwc-badge-fill-free'
  | 'fwc-badge-fill-new'
  | 'fwc-badge-fill-blue'
  | 'fwc-badge-fill-teal'
  | 'fwc-badge-fill-teal-dark'
  | 'fwc-badge-fill-green'
  | 'fwc-badge-fill-yellow'
  | 'fwc-badge-fill-orange'
  | 'fwc-badge-fill-magenta'
  | 'fwc-badge-fill-purple'
  | 'fwc-badge-fill-red'
  | 'fwc-badge-border-calypso'
  | 'fwc-badge-border-candy-apple'
  | 'fwc-badge-border-koala'
  | 'fwc-badge-border-lorax'
  | 'fwc-badge-border-marigold'
  | 'fwc-badge-border-norman'
  | 'fwc-badge-border-oz'
  | 'fwc-badge-border-pantera'
  | 'fwc-badge-border-sorbet'
  | 'fwc-badge-border-thunderdome'
  | 'fwc-badge-border-beta'
  | 'fwc-badge-border-free'
  | 'fwc-badge-border-new'
  | 'fwc-badge-border-blue'
  | 'fwc-badge-border-teal'
  | 'fwc-badge-border-teal-dark'
  | 'fwc-badge-border-green'
  | 'fwc-badge-border-yellow'
  | 'fwc-badge-border-orange'
  | 'fwc-badge-border-magenta'
  | 'fwc-badge-border-purple'
  | 'fwc-badge-border-red'
  | 'fwc-button-border-core-default'
  | 'fwc-button-border-core-hover'
  | 'fwc-button-border-tertiary-on-fill-disabled'
  | 'fwc-button-border-core-on-fill-default'
  | 'fwc-button-border-inverse-default'
  | 'fwc-button-border-inverse-default-alt'
  | 'fwc-button-border-inverse-disabled'
  | 'fwc-button-border-inverse-disabled-alt'
  | 'fwc-button-border-primary-default'
  | 'fwc-button-border-primary-on-fill-default'
  | 'fwc-button-border-primary-disabled'
  | 'fwc-button-border-primary-hover'
  | 'fwc-button-border-primary-pressed'
  | 'fwc-button-border-secondary-default'
  | 'fwc-button-border-secondary-default-alt'
  | 'fwc-button-border-secondary-disabled'
  | 'fwc-button-border-secondary-disabled-alt'
  | 'fwc-button-border-tertiary-default'
  | 'fwc-button-border-tertiary-disabled'
  | 'fwc-button-border-transitional-tertiary-default'
  | 'fwc-button-fill-alert-default'
  | 'fwc-button-fill-alert-hover'
  | 'fwc-button-fill-alert-pressed'
  | 'fwc-button-fill-field-default-alt'
  | 'fwc-button-fill-inverse-default'
  | 'fwc-button-fill-inverse-default-alt'
  | 'fwc-button-fill-inverse-disabled'
  | 'fwc-button-fill-inverse-disabled-alt'
  | 'fwc-button-fill-inverse-hover'
  | 'fwc-button-fill-inverse-hover-alt'
  | 'fwc-button-fill-inverse-pressed'
  | 'fwc-button-fill-inverse-pressed-alt'
  | 'fwc-button-fill-primary-default'
  | 'fwc-button-fill-primary-disabled'
  | 'fwc-button-fill-primary-hover'
  | 'fwc-button-fill-primary-pressed'
  | 'fwc-button-fill-secondary-default'
  | 'fwc-button-fill-secondary-default-alt'
  | 'fwc-button-fill-secondary-disabled'
  | 'fwc-button-fill-secondary-disabled-alt'
  | 'fwc-button-fill-secondary-hover'
  | 'fwc-button-fill-secondary-hover-alt'
  | 'fwc-button-fill-secondary-pressed'
  | 'fwc-button-fill-secondary-pressed-alt'
  | 'fwc-button-fill-surface-default'
  | 'fwc-button-fill-surface-raised'
  | 'fwc-button-fill-tertiary-default'
  | 'fwc-button-fill-tertiary-disabled'
  | 'fwc-button-fill-tertiary-hover'
  | 'fwc-button-fill-tertiary-pressed'
  | 'fwc-button-fill-transitional-tertiary-default'
  | 'fwc-button-fill-transitional-tertiary-hover'
  | 'fwc-button-fill-transitional-tertiary-pressed'
  | 'fwc-button-fill-transparent-default'
  | 'fwc-button-specialty-link-on-fill-alt-default'
  | 'fwc-button-specialty-link-on-fill-alt-pressed'
  | 'fwc-button-specialty-link-on-fill-default'
  | 'fwc-button-specialty-link-on-fill-disabled'
  | 'fwc-button-specialty-link-on-fill-hover'
  | 'fwc-button-specialty-link-on-fill-pressed'
  | 'fwc-button-specialty-primary-on-fill-default'
  | 'fwc-button-specialty-primary-on-fill-disabled'
  | 'fwc-button-specialty-primary-on-fill-hover'
  | 'fwc-button-specialty-primary-on-fill-pressed'
  | 'fwc-button-specialty-tertiary-on-fill-default'
  | 'fwc-button-specialty-tertiary-on-fill-disabled'
  | 'fwc-button-specialty-tertiary-on-fill-hover'
  | 'fwc-button-specialty-tertiary-on-fill-pressed'
  | 'fwc-button-specialty-secondary-toolbar-default'
  | 'fwc-button-specialty-secondary-toolbar-disabled'
  | 'fwc-button-specialty-secondary-toolbar-hover'
  | 'fwc-button-specialty-secondary-toolbar-pressed'
  | 'fwc-button-border-secondary-toolbar-default'
  | 'fwc-button-border-secondary-toolbar-disabled'
  | 'fwc-button-text-secondary-toolbar-default'
  | 'fwc-button-text-secondary-toolbar-disabled'
  | 'fwc-button-specialty-tertiary-transparent-default'
  | 'fwc-button-specialty-tertiary-transparent-disabled'
  | 'fwc-button-specialty-tertiary-transparent-hover'
  | 'fwc-button-specialty-tertiary-transparent-pressed'
  | 'fwc-button-specialty-text-core-alt-default'
  | 'fwc-button-specialty-text-interactive-alt-default'
  | 'fwc-button-specialty-text-interactive-alt-hover'
  | 'fwc-button-specialty-text-interactive-alt-pressed'
  | 'fwc-button-text-alert-default'
  | 'fwc-button-text-alert-hover'
  | 'fwc-button-text-alert-on-fill-default'
  | 'fwc-button-text-alert-pressed'
  | 'fwc-button-text-core-default'
  | 'fwc-button-text-core-disabled'
  | 'fwc-button-text-secondary-ghost-disabled'
  | 'fwc-button-text-primary-on-fill-disabled'
  | 'fwc-button-text-interactive-default'
  | 'fwc-button-text-interactive-default-disabled'
  | 'fwc-button-text-interactive-default-hover'
  | 'fwc-button-text-interactive-default-pressed'
  | 'fwc-button-text-inverse-default'
  | 'fwc-button-text-inverse-default-alt'
  | 'fwc-button-text-inverse-disabled'
  | 'fwc-button-text-inverse-disabled-alt'
  | 'fwc-button-text-inverse-hover'
  | 'fwc-button-text-inverse-pressed'
  | 'fwc-button-text-primary-default'
  | 'fwc-button-text-primary-disabled'
  | 'fwc-button-text-secondary-default'
  | 'fwc-button-text-secondary-disabled'
  | 'fwc-button-text-tertiary-default'
  | 'fwc-button-text-tertiary-disabled'
  | 'fwc-button-text-tertiary-on-fill-disabled'
  | 'fwc-link-icon-alert-default'
  | 'fwc-link-icon-core-default'
  | 'fwc-link-icon-interactive-default'
  | 'fwc-link-icon-interactive-on-fill-default'
  | 'fwc-link-specialty-link-on-fill-alt-default'
  | 'fwc-link-specialty-link-on-fill-alt-disabled'
  | 'fwc-link-specialty-link-on-fill-alt-hover'
  | 'fwc-link-specialty-link-on-fill-alt-pressed'
  | 'fwc-link-specialty-link-on-fill-default'
  | 'fwc-link-specialty-link-on-fill-disabled'
  | 'fwc-link-specialty-link-on-fill-hover'
  | 'fwc-link-specialty-link-on-fill-pressed'
  | 'fwc-link-specialty-text-core-alt-default'
  | 'fwc-link-specialty-text-interactive-alt-default'
  | 'fwc-link-specialty-text-interactive-alt-hover'
  | 'fwc-link-specialty-text-interactive-alt-pressed'
  | 'fwc-link-text-alert-default'
  | 'fwc-link-text-alert-hover'
  | 'fwc-link-text-alert-pressed'
  | 'fwc-link-text-core-default'
  | 'fwc-link-text-core-disabled'
  | 'fwc-link-text-interactive-default'
  | 'fwc-link-text-interactive-default-disabled'
  | 'fwc-link-text-interactive-default-hover'
  | 'fwc-link-text-interactive-default-pressed'
  | 'fwc-link-underline-default'
  | 'fwc-link-underline-disabled'
  | 'fwc-link-underline-hover'
  | 'fwc-link-underline-pressed'
  | 'fwc-loadingspinner-indicator-danger'
  | 'fwc-loadingspinner-indicator-ghost'
  | 'fwc-loadingspinner-indicator-link'
  | 'fwc-loadingspinner-indicator-onfill'
  | 'fwc-loadingspinner-indicator-primary'
  | 'fwc-loadingspinner-indicator-success'
  | 'fwc-loadingspinner-indicator-tertiary'
  | 'fwc-loadingspinner-ring-danger'
  | 'fwc-loadingspinner-ring-ghost'
  | 'fwc-loadingspinner-ring-link'
  | 'fwc-loadingspinner-ring-onfill'
  | 'fwc-loadingspinner-ring-primary'
  | 'fwc-loadingspinner-ring-success'
  | 'fwc-loadingspinner-ring-tertiary'
  | 'fwc-progress-fill-alert-default'
  | 'fwc-progress-fill-empty'
  | 'fwc-progress-text-default'
  | 'fwc-radio-border-default'
  | 'fwc-radio-border-readonly'
  | 'fwc-radio-fill-readonly-indicator'
  | 'fwc-radio-text-readonly'
  | 'fwc-ribbon-fill-beta'
  | 'fwc-ribbon-fill-calypso'
  | 'fwc-ribbon-fill-candy-apple'
  | 'fwc-ribbon-fill-free'
  | 'fwc-ribbon-fill-heffalump'
  | 'fwc-ribbon-fill-koala'
  | 'fwc-ribbon-fill-lorax'
  | 'fwc-ribbon-fill-marigold'
  | 'fwc-ribbon-fill-new'
  | 'fwc-ribbon-fill-norman'
  | 'fwc-ribbon-fill-olaf'
  | 'fwc-ribbon-fill-oz'
  | 'fwc-ribbon-fill-pantera'
  | 'fwc-ribbon-fill-sorbet'
  | 'fwc-ribbon-fill-thunderdome'
  | 'fwc-searchinput-border-default'
  | 'fwc-selectable-border-default'
  | 'fwc-selectable-border-selected'
  | 'fwc-table-border-color-default'
  | 'fwc-table-header-divider-color-default'
  | 'fwc-table-header-text-default'
  | 'fwc-table-header-top-border-color-default'
  | 'fwc-table-divider-color-emphasis'
  | 'fwc-tag-border-badge-calypso'
  | 'fwc-tag-border-badge-candy-apple'
  | 'fwc-tag-border-badge-green'
  | 'fwc-tag-border-badge-koala'
  | 'fwc-tag-border-badge-lorax'
  | 'fwc-tag-border-badge-magenta'
  | 'fwc-tag-border-badge-marigold'
  | 'fwc-tag-border-badge-norman'
  | 'fwc-tag-border-badge-oz'
  | 'fwc-tag-border-badge-pantera'
  | 'fwc-tag-border-badge-purple'
  | 'fwc-tag-border-badge-red'
  | 'fwc-tag-border-badge-sorbet'
  | 'fwc-tag-border-badge-teal'
  | 'fwc-tag-border-badge-teal-dark'
  | 'fwc-tag-border-badge-thunderdome'
  | 'fwc-tag-border-badge-yellow'
  | 'fwc-tag-border-badge-blue'
  | 'fwc-tag-border-badge-orange'
  | 'fwc-tag-border-calypso'
  | 'fwc-tag-border-candy-apple'
  | 'fwc-tag-border-default'
  | 'fwc-tag-border-green'
  | 'fwc-tag-border-heffalump'
  | 'fwc-tag-border-koala'
  | 'fwc-tag-border-lorax'
  | 'fwc-tag-border-magenta'
  | 'fwc-tag-border-marigold'
  | 'fwc-tag-border-norman'
  | 'fwc-tag-border-olaf'
  | 'fwc-tag-border-orange'
  | 'fwc-tag-border-oz'
  | 'fwc-tag-border-pantera'
  | 'fwc-tag-border-purple'
  | 'fwc-tag-border-red'
  | 'fwc-tag-border-sorbet'
  | 'fwc-tag-border-subtle'
  | 'fwc-tag-border-teal'
  | 'fwc-tag-border-teal-dark'
  | 'fwc-tag-border-teal-light'
  | 'fwc-tag-border-thunderdome'
  | 'fwc-tag-border-blue'
  | 'fwc-tag-border-yellow'
  | 'fwc-tag-fill-badge-calypso'
  | 'fwc-tag-fill-badge-candy-apple'
  | 'fwc-tag-fill-badge-green'
  | 'fwc-tag-fill-badge-koala'
  | 'fwc-tag-fill-badge-lorax'
  | 'fwc-tag-fill-badge-magenta'
  | 'fwc-tag-fill-badge-marigold'
  | 'fwc-tag-fill-badge-norman'
  | 'fwc-tag-fill-badge-oz'
  | 'fwc-tag-fill-badge-pantera'
  | 'fwc-tag-fill-badge-purple'
  | 'fwc-tag-fill-badge-red'
  | 'fwc-tag-fill-badge-sorbet'
  | 'fwc-tag-fill-badge-teal'
  | 'fwc-tag-fill-badge-teal-dark'
  | 'fwc-tag-fill-badge-thunderdome'
  | 'fwc-tag-fill-badge-yellow'
  | 'fwc-tag-fill-badge-blue'
  | 'fwc-tag-fill-badge-orange'
  | 'fwc-tag-fill-calypso'
  | 'fwc-tag-fill-candy-apple'
  | 'fwc-tag-fill-default'
  | 'fwc-tag-fill-green'
  | 'fwc-tag-fill-heffalump'
  | 'fwc-tag-fill-koala'
  | 'fwc-tag-fill-lorax'
  | 'fwc-tag-fill-magenta'
  | 'fwc-tag-fill-marigold'
  | 'fwc-tag-fill-norman'
  | 'fwc-tag-fill-olaf'
  | 'fwc-tag-fill-orange'
  | 'fwc-tag-fill-oz'
  | 'fwc-tag-fill-pantera'
  | 'fwc-tag-fill-purple'
  | 'fwc-tag-fill-red'
  | 'fwc-tag-fill-sorbet'
  | 'fwc-tag-fill-subtle'
  | 'fwc-tag-fill-teal'
  | 'fwc-tag-fill-teal-dark'
  | 'fwc-tag-fill-teal-light'
  | 'fwc-tag-fill-thunderdome'
  | 'fwc-tag-fill-blue'
  | 'fwc-tag-fill-yellow'
  | 'fwc-tag-text-marigold'
  | 'fwc-tag-text-onfill'
  | 'fwc-tag-text-subtle'
  | 'fwc-textinput-border-readonly'
  | 'fwc-textinput-fill-readonly'
  | 'fwc-toggle-border-readonly'
  | 'fwc-link-underline-inherit-idle'
  | 'fwc-ai-button-border-secondary-default'
  | 'fwc-ai-button-border-secondary-hover'
  | 'fwc-ai-button-border-secondary-pressed'
  | 'fwc-ai-button-fill-primary-default'
  | 'fwc-ai-button-fill-primary-hover'
  | 'fwc-ai-button-fill-primary-pressed';

export type FwcBorderRadius =
  | 'fwc-alert'
  | 'fwc-button'
  | 'fwc-dropdown-options-container'
  | 'fwc-expandabletext-scrollable-container'
  | 'fwc-progress'
  | 'fwc-select-options-container'
  | 'fwc-tag'
  | 'fwc-tag-badge';

export type FwcBorderWidth =
  | 'fwc-alert-100'
  | 'fwc-table-header-divider-width-default';

export type FwcFontSize = 'fwc-table-header-font-size';

export type FwcFontWeight =
  | 'fwc-table-header-font-weight'
  | 'fwc-button-font-weight';

export function fwcColor(token: FwcColor): Color {
  return token as unknown as Color;
}

export function fwcBorderRadius(token: FwcBorderRadius): BorderRadius {
  return token as unknown as BorderRadius;
}

export function fwcBorderWidth(token: FwcBorderWidth): BorderWidth {
  return token as unknown as BorderWidth;
}

export function fwcFontSize(token: FwcFontSize): FontSize {
  return token as unknown as FontSize;
}

export function fwcFontWeight(token: FwcFontWeight): FontWeight {
  return token as unknown as FontWeight;
}
